import { useEffect, useRef, useState } from "react";

export type QuickAction = "hist_24h" | "hist_today" | "hist_yesterday" | "follow" | "share" | "alerts" | "address" | "display";

/** "⋯" menu for an object (list rows and the detail strip). */
export default function QuickMenu({ onAction, following, canEdit = false }: { onAction: (a: QuickAction) => void; following: boolean; canEdit?: boolean }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); };
    const esc = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", close); document.removeEventListener("keydown", esc); };
  }, [open]);
  const go = (a: QuickAction) => (e: React.MouseEvent) => { e.stopPropagation(); setOpen(false); onAction(a); };
  return (
    <div className="qm" ref={ref} onClick={(e) => e.stopPropagation()}>
      <button className="qm-btn" aria-label="More actions" aria-expanded={open} onClick={() => setOpen(!open)}>⋯</button>
      {open && (
        <div className="qm-menu" role="menu">
          <div className="qm-label">History</div>
          <button role="menuitem" onClick={go("hist_24h")}>Last 24 hours</button>
          <button role="menuitem" onClick={go("hist_today")}>Today</button>
          <button role="menuitem" onClick={go("hist_yesterday")}>Last day (yesterday)</button>
          <hr />
          <button role="menuitem" onClick={go("follow")}>{following ? "Stop following" : "Follow in a window"}</button>
          <button role="menuitem" onClick={go("share")}>Share live location…</button>
          <button role="menuitem" onClick={go("alerts")}>Alerts…</button>
          <button role="menuitem" onClick={go("address")}>Show location</button>
          {canEdit && <button role="menuitem" onClick={go("display")}>Icon &amp; tail…</button>}
        </div>
      )}
    </div>
  );
}
